import { createContext, useContext, useState } from "react";
import { ShowNotification } from "../../components/shared/ShowNotification";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notificationCount, setNotificationCount] = useState(0);

  return (
    <NotificationContext.Provider
      value={{ notificationCount, setNotificationCount }}
    >
      {children}
      <ShowNotification />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
